import { QuestionsFields, SourceFields } from '@components';
import { API_URL, sortByKey } from '@utilities';

export type Source = {
	id: number;
	last_updated: string;
	name_long: string;
	name_short: string;
	name_slug: string;
	homepage: string;
	contact: string;
	capable_dmarc: boolean;
	capable_spf: boolean;
	capable_dkim: boolean;
	notes_dmarc: string;
	notes_spf: string;
	notes_dkim: string;
	notes_fwd: string;
	forwarder: boolean;
	forwarder_only: boolean;
	fwd_preserves_dkim: boolean;
	fwd_uses_own_envelope: boolean;
	static_source: boolean;
	static_source_notes: string;
	industry_links: Record<string, string>;
};

export const getDataFromAPI = async (endpoint: 'sources' | 'forwarders'): Promise<Source[]> => {
	try {
		const response = await fetch(`${API_URL}/api/v1/${endpoint}/`);
		const data: Source[] = await response.json();

		return Promise.resolve(sortByKey(data, 'name_long'));
	} catch (e) {
		return Promise.reject([]);
	}
};

export const postDataToAPI = async (
	data: QuestionsFields | SourceFields,
	endpoint: 'create-sources' | 'contact'
): Promise<void> => {
	try {
		const { status } = await fetch(`${API_URL}/api/v1/${endpoint}/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		});

		if (status < 200 || status >= 300) {
			return Promise.reject();
		}

		return Promise.resolve();
	} catch (e) {
		return Promise.reject();
	}
};

export const getSources = async () => await getDataFromAPI('sources');

export const getForwarders = async () => await getDataFromAPI('forwarders');

export const postSource = async (data: SourceFields) => await postDataToAPI(data, 'create-sources');

export const postMessage = async (data: QuestionsFields) => await postDataToAPI(data, 'contact');
